/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, e as normalizeNumber, n as normalizeString, f as createDependentPropDefinition } from './normalizers-BNeak4hj.js';

const maxProp = createPropDefinition('max', 100, normalizeNumber, (v) => v > 0);

const unitProp = createPropDefinition('unit', '%', normalizeString, (v) => v.length > 0);

const clampedNumberValueProp = createDependentPropDefinition('value', 0, (value, deps) => {
    const normalized = normalizeNumber(value);
    if (normalized < deps.min) {
        return deps.min;
    }
    else if (normalized > deps.max) {
        return deps.max;
    }
    return normalized;
}, (v) => v !== undefined && v !== null);

export { clampedNumberValueProp as c, maxProp as m, unitProp as u };
//# sourceMappingURL=value-number-clamped-Fuextuj1.js.map

//# sourceMappingURL=value-number-clamped-Fuextuj1.js.map